"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Spinner = _interopRequireDefault(require("../Spinner"));

var _Error = _interopRequireDefault(require("../Error"));

var _config = require("../config/config");

var _loadScript = _interopRequireDefault(require("../_utils/loadScript"));

require("./map.sass");

var Map =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Map, _Component);

  function Map() {
    (0, _classCallCheck2.default)(this, Map);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf3.default)(Map).apply(this, arguments));
  }

  (0, _createClass2.default)(Map, [{
    key: "render",
    value: function render() {
      var address = this.props.address;
      return _react.default.createElement(RawMap, {
        address: address,
        key: address
      });
    }
  }]);
  return Map;
}(_react.Component);

exports.default = Map;
Map.propTypes = process.env.NODE_ENV !== "production" ? {
  address: _propTypes.default.string.isRequired
} : {};

var _ref3 = _react.default.createElement(_Spinner.default, null);

var RawMap =
/*#__PURE__*/
function (_Component2) {
  (0, _inherits2.default)(RawMap, _Component2);

  function RawMap() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, RawMap);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(RawMap)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onMapReady", function () {
      _this.geocode(_this.props.address);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "geocodeResult", function (address) {
      return function (results, status) {
        if (_this.props.address !== address) {
          // Outdated response, address has already changed
          // drop that result
          return;
        }

        if (!window.google || !window.google.maps) {
          // Very strange, but geocode result arrived before google maps services enabled. WTF?
          _this.setState({
            error: (0, _config.__)('Error while loading map')
          });

          return;
        }

        var _window$google$maps = window.google.maps,
            Map = _window$google$maps.Map,
            Marker = _window$google$maps.Marker,
            MapTypeId = _window$google$maps.MapTypeId,
            InfoWindow = _window$google$maps.InfoWindow,
            GeocoderStatus = _window$google$maps.GeocoderStatus;

        if (status !== GeocoderStatus.OK || !results || !results.length) {
          _this.setState({
            error: (0, _config.__)('Coudn\'t find address %s', address)
          });

          return;
        }

        var result = results[0];
        var map = new Map(_this.refs.element, {
          zoom: 16,
          center: result.geometry.location,
          mapTypeId: MapTypeId.ROADMAP,
          scrollwheel: false
        });

        if (result.geometry.bounds) {
          map.fitBounds(result.geometry.bounds);
        }

        var marker = new Marker({
          position: result.geometry.location,
          map: map
        });
        var infowindow = new InfoWindow({
          content: result.formatted_address
        });
        infowindow.open(map, marker);
      };
    });
    return _this;
  }

  (0, _createClass2.default)(RawMap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.scriptLoader = (0, _loadScript.default)('https://maps.google.com/maps/api/js?v=3&sensor=true', this.onMapReady);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.scriptLoader.unsubscribe();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_ref, _ref2) {
      var address = _ref.address;
      var error = _ref2.error;

      if (address !== this.props.address) {
        return true;
      }

      return !!error;
    }
  }, {
    key: "geocode",
    value: function geocode(address) {
      if (!window.google || !window.google.maps) {
        // can't geocode — google maps not ready
        this.setState({
          error: (0, _config.__)('Error while loading map')
        });
        return;
      }

      var gecoder = new window.google.maps.Geocoder();
      gecoder.geocode({
        address: address
      }, this.geocodeResult(address));
    }
  }, {
    key: "render",
    value: function render() {
      var error = this.state.error;
      return _react.default.createElement("div", {
        className: "map",
        ref: "element"
      }, error ? _react.default.createElement(_Error.default, {
        message: error
      }) : _ref3);
    }
  }]);
  return RawMap;
}(_react.Component);

RawMap.propTypes = process.env.NODE_ENV !== "production" ? {
  address: _propTypes.default.string.isRequired
} : {};